module.exports = __webpack_public_path__ + "static/fonts/Poppins-ExtraLight.6f8391b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-ExtraLight.ttf
// module id = 1025
// module chunks = 11